import { IconNameEnum } from "@b2bportal/core-themes";
import AirplaneArrive from "../../assets/client/airplane-arrive.svg";
import AirplanDepartChfar from "../../assets/client/airplane-depart-chfar.svg";
import AirplaneDepart from "../../assets/client/airplane-depart.svg";
import AirplaneFintech from "../../assets/client/airplane-fintech.svg";
import Airplane from "../../assets/client/airplane.svg";
import ArrowFork from "../../assets/client/arrow-fork.svg";
import Bell from "../../assets/client/bell.svg";
import BlackLock from "../../assets/client/black-lock.svg";
import BriefCase from "../../assets/client/briefcase-detail.svg";
import CalendarLoading from "../../assets/client/calendar-loading.svg";
import Calendar from "../../assets/client/calendar.svg";
import Cancel from "../../assets/client/cancel.svg";
import Card from "../../assets/client/card.svg";
import CheckmarkFilled from "../../assets/client/checkmark-filled.svg";
import CheckmarkSimple from "../../assets/client/checkmark-simple.svg";
import Checkmark from "../../assets/client/checkmark.svg";
import Chevron from "../../assets/client/chevron.svg";
import CircleCheck from "../../assets/client/circle-check.svg";
import ClockSolo from "../../assets/client/clock-solo.svg";
import Clock from "../../assets/client/clock.svg";
import AirplaneArriveWhite from "../../assets/client/darkMode/airplane-arrive-white.svg";
import AirplanDepartChfarWhite from "../../assets/client/darkMode/airplane-depart-chfar-white.svg";
import AirplaneDepartWhite from "../../assets/client/darkMode/airplane-depart-white.svg";
import AirplaneWhite from "../../assets/client/darkMode/airplane-white.svg";
import ArrowForkWhite from "../../assets/client/darkMode/arrow-fork-white.svg";
import BellWhite from "../../assets/client/darkMode/bell-white.svg";
import CalendarWhite from "../../assets/client/darkMode/calendar-white.svg";
import CancelWhite from "../../assets/client/darkMode/cancel.svg";
import CardWhite from "../../assets/client/darkMode/card-white.svg";
import CheckmarkSimpleWhite from "../../assets/client/darkMode/checkmark-simple-white.svg";
import CheckmarkWhite from "../../assets/client/darkMode/checkmark-white.svg";
import FilterWhite from "../../assets/client/darkMode/filter-white.svg";
import InfoGrey from "../../assets/client/darkMode/info-grey.svg";
import LocationMarkerWhite from "../../assets/client/darkMode/location-marker-white.svg";
import LockLargeWhite from "../../assets/client/darkMode/lock-large-white.svg";
import LockWhite from "../../assets/client/darkMode/lock-white.svg";
import MissedConnectionWhite from "../../assets/client/darkMode/missed-connection-white.svg";
import OneWayWhite from "../../assets/client/darkMode/oneway-white.svg";
import PassengerWhite from "../../assets/client/darkMode/passenger-white.svg";
import PriceFreezeWhite from "../../assets/client/darkMode/price-freeze-white.svg";
import RefreshWhite from "../../assets/client/darkMode/refresh-white.svg";
import RoundTripWhite from "../../assets/client/darkMode/roundtrip-white.svg";
import ShieldDisruptionWhite from "../../assets/client/darkMode/shield-disruption-white.svg";
import ShieldWhite from "../../assets/client/darkMode/shield-white.svg";
import TicketWhite from "../../assets/client/darkMode/ticket-white.svg";
import WarningTriangleWhite from "../../assets/client/darkMode/warning-triangle.svg";
import WarningWhite from "../../assets/client/darkMode/warning-white.svg";
import DollarBill from "../../assets/client/dollar-bill.svg";
import ErrorIcon from "../../assets/client/error.svg";
import Filter from "../../assets/client/filter.svg";
import Headset from "../../assets/client/headset.svg";
import Info from "../../assets/client/info.svg";
import LocationMarker from "../../assets/client/location-marker.svg";
import Lock from "../../assets/client/lock.svg";
import MagnifyCheck from "../../assets/client/magnify-check.svg";
import MissedConnectionBlack from "../../assets/client/missed-connection-black.svg";
import MissedConnection from "../../assets/client/missed-connection.svg";
import OneWay from "../../assets/client/oneway.svg";
import Passenger from "../../assets/client/passenger.svg";
import PriceFreeze from "../../assets/client/price-freeze.svg";
import Refresh from "../../assets/client/refresh.svg";
import RoundTrip from "../../assets/client/roundtrip.svg";
import ShieldDisruption from "../../assets/client/shield-disruption.svg";
import Shield from "../../assets/client/shield.svg";
import Ticket from "../../assets/client/ticket.svg";
import Warning from "../../assets/client/warning-black.svg";
import WarningTriangle from "../../assets/client/warning-triangle.svg";
import WarningError from "../../assets/client/warning.svg";
// Dark Mode Icons

export const darkModeIcons = {
  airplane: AirplaneWhite,
  airplaneArrive: AirplaneArriveWhite,
  airplaneDepart: AirplaneDepartWhite,
  airplaneFintech: AirplaneFintech,
  bell: BellWhite,
  calendar: CalendarWhite,
  card: CardWhite,
  clock: Clock,
  error: ErrorIcon,
  cancel: CancelWhite,
  checkmark: CheckmarkWhite,
  checkmarkFilled: CheckmarkFilled,
  checkmarkSimple: CheckmarkSimpleWhite,
  chevron: Chevron,
  circleCheck: CircleCheck,
  filter: FilterWhite,
  info: InfoGrey,
  locationMarker: LocationMarkerWhite,
  lock: LockLargeWhite,
  blackLock: LockWhite,
  oneway: OneWayWhite,
  roundtrip: RoundTripWhite,
  passenger: PassengerWhite,
  priceFreeze: PriceFreezeWhite,
  missedConnection: MissedConnection,
  shield: ShieldWhite,
  warning: WarningWhite,
  warningError: WarningError,
  warningTriangle: WarningTriangleWhite,
  shieldDisruption: ShieldDisruptionWhite,
  missedConnectionFintech: MissedConnectionWhite,
  airplaneDepartChfar: AirplanDepartChfarWhite,
  refresh: RefreshWhite,
  ticket: TicketWhite,
  arrowFork: ArrowForkWhite,
  magnifyCheck: MagnifyCheck,
  calendarLoading: CalendarLoading,
  clockSolo: ClockSolo,
  dollarBill: DollarBill,
  briefcase: BriefCase,
  [IconNameEnum.disruptionProtection]: AirplaneFintech,
  [IconNameEnum.disruptionHowItWorksDialogInfoLineOne]: WarningWhite,
  [IconNameEnum.disruptionHowItWorksDialogInfoLineTwo]: AirplaneWhite,
  [IconNameEnum.rightArrow]: ArrowFork,
  [IconNameEnum.disruptionConfirmationIcon]: CheckmarkWhite,
};

export const lightModeIcons = {
  airplane: Airplane,
  airplaneArrive: AirplaneArrive,
  airplaneDepart: AirplaneDepart,
  airplaneFintech: AirplaneFintech,
  bell: Bell,
  calendar: Calendar,
  cancel: Cancel,
  card: Card,
  clock: Clock,
  error: ErrorIcon,
  checkmark: Checkmark,
  checkmarkFilled: CheckmarkFilled,
  checkmarkSimple: CheckmarkSimple,
  chevron: Chevron,
  circleCheck: CircleCheck,
  filter: Filter,
  info: Info,
  locationMarker: LocationMarker,
  lock: Lock,
  blackLock: BlackLock,
  oneway: OneWay,
  roundtrip: RoundTrip,
  passenger: Passenger,
  priceFreeze: PriceFreeze,
  missedConnection: MissedConnection,
  shield: Shield,
  warning: Warning,
  warningError: WarningError,
  warningTriangle: WarningTriangle,
  shieldDisruption: ShieldDisruption,
  missedConnectionFintech: MissedConnectionBlack,
  airplaneDepartChfar: AirplanDepartChfar,
  refresh: Refresh,
  ticket: Ticket,
  arrowFork: ArrowFork,
  magnifyCheck: MagnifyCheck,
  calendarLoading: CalendarLoading,
  clockSolo: ClockSolo,
  dollarBill: DollarBill,
  briefcase: BriefCase,
  [IconNameEnum.disruptionProtection]: AirplaneFintech,
  [IconNameEnum.disruptionHowItWorksDialogInfoLineOne]: Warning,
  [IconNameEnum.disruptionHowItWorksDialogInfoLineTwo]: Airplane,
  [IconNameEnum.disruptionHowItWorksDialogBulletOne]: AirplaneDepart,
  [IconNameEnum.disruptionHowItWorksDialogBulletTwo]: Card,
  [IconNameEnum.disruptionHowItWorksDialogBulletThree]: Headset,
  [IconNameEnum.disruptionBulletPointOne]: AirplaneDepart,
  [IconNameEnum.disruptionBulletPointTwo]: Card,
  [IconNameEnum.disruptionBulletPointThree]: Headset,
  [IconNameEnum.rightArrow]: ArrowFork,
  [IconNameEnum.disruptionConfirmationIcon]: Checkmark,
};
